import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  Class as ClassIcon,
} from '@mui/icons-material';
import PageHeader from '../../components/common/PageHeader';
import ClassSessions from './components/ClassSessions';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tutors-tabpanel-${index}`}
      aria-labelledby={`tutors-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `tutors-tab-${index}`,
    'aria-controls': `tutors-tabpanel-${index}`,
  };
}

const Tutors: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <PageHeader
        title="Tutors"
        subtitle="Manage your class sessions and teaching assignments"
      />

      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="tutors tabs">
            <Tab 
              icon={<ClassIcon />} 
              label="Class Sessions" 
              {...a11yProps(0)} 
              iconPosition="start"
            />
          </Tabs>
        </Box>
        
        <TabPanel value={value} index={0}>
          <ClassSessions />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default Tutors;
